<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Authorised Workshop</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /
      <b>Authorized Workshop</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <!-- Brunei Muara -->
              <li class="nav-item">
                <a
                  class="nav-link active show"
                  id="brunei-tab"
                  data-toggle="tab"
                  href="#brunei"
                  role="tab"
                  aria-controls="brunei"
                  aria-selected="true"
                  >Brunei Muara</a
                >
              </li>

              <!-- Tutong -->
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tutong-tab"
                  data-toggle="tab"
                  href="#tutong"
                  role="tab"
                  aria-controls="tutong"
                  aria-selected="false"
                  >Tutong</a
                >
              </li>

              <!-- Belait -->
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="belait-tab"
                  data-toggle="tab"
                  href="#belait"
                  role="tab"
                  aria-controls="belait"
                  aria-selected="false"
                  >Belait</a
                >
              </li>

              <!-- Temburong -->
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="temburong-tab"
                  data-toggle="tab"
                  href="#temburong"
                  role="tab"
                  aria-controls="temburong"
                  aria-selected="false"
                  >Temburong</a
                >
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <brunei :brunei="brunei"></brunei>
              <tutong></tutong>
              <belait></belait>
              <temburong></temburong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Brunei from "@/views/contents/workshop/Workshop_brunei.vue";
import Tutong from "@/views/contents/workshop/Workshop_tutong.vue";
import Belait from "@/views/contents/workshop/Workshop_belait.vue";
import Temburong from "@/views/contents/workshop/Workshop_temburong.vue";

export default {
  name: "authorised_workshop",
  components: {
    Brunei,
    Tutong,
    Belait,
    Temburong
  },

  data() {
    return {
      brunei: [],
      tutong: [],
      belait: [],
      temburong: []
    };
  }
};
</script>

<style>
.active {
  background: none;
}
</style>
